<template>
  <ActivitiesList :hasFilterMatter="true" />
</template>

<script>
import ActivitiesList from "@/views/activites/ActivitesList";
export default {
  components:{ActivitiesList},
  methods: {

  },
  mounted() {
    console.log('asas')
  }
}
</script>
